import React from 'react';

const Home: React.FC = () => <h1>Site em desenvolvimento</h1>;

export default Home;
